import { DEFAULT_LANGUAGE, SITE_URL } from './config';

export const normalizePath = (pathname = '/') => {
  if (!pathname || pathname === '/') {
    return '/';
  }

  return pathname.startsWith('/') ? pathname.replace(/\/+$/, '') || '/' : `/${pathname.replace(/\/+$/, '')}`;
};

export const buildLocalizedPath = (pathname, language = DEFAULT_LANGUAGE) => {
  const path = normalizePath(pathname);

  if (language === 'en') {
    return path === '/' ? '/?lang=en' : `${path}?lang=en`;
  }

  return path;
};

export const absoluteUrl = (pathname, language = DEFAULT_LANGUAGE) => {
  const localizedPath = buildLocalizedPath(pathname, language);

  if (localizedPath === '/') {
    return SITE_URL;
  }

  if (localizedPath.startsWith('/?')) {
    return `${SITE_URL}${localizedPath}`;
  }

  return `${SITE_URL}${localizedPath}`;
};

export const buildAlternateUrls = (pathname) => ({
  en: absoluteUrl(pathname, 'en'),
  fa: absoluteUrl(pathname, 'fa'),
  'x-default': absoluteUrl(pathname, DEFAULT_LANGUAGE)
});

export const getLanguageFromSearch = (search = '') => {
  const params = new URLSearchParams(search);
  const lang = params.get('lang');
  return lang === 'en' ? 'en' : 'fa';
};
